import React from 'react';

const Contact = () => {
  return (
    <div className="min-h-screen  py-10 px-4">

<div className="bg-gray-900 text-white   py-12 px-4">
<h2 className="text-3xl font-bold    text-left">39 BILSTON ROAD, WILLENHALL, WEST MIDLANDS, UNITED KINGDOM</h2>
<h2 className="text-1xl font-bold   text-left">moreinfo@sadhavideo.com</h2>
<h2 className="text-1xl font-bold   text-left">01902 604950</h2>




</div>
      <div className="      rounded-lg shadow-md">
        
      
        {/* Google Map */}
        <div className="w-full h-96">
          <iframe
            title="Google Map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2424.683070874136!2d-2.0608139238036416!3d52.575342432131286!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487099142b2096c9%3A0xbfb64378dabd1afa!2s39%20Bilston%20Rd%2C%20Wolverhampton%2C%20Willenhall%20WV13%202JT!5e0!3m2!1sen!2suk!4v1746389835469!5m2!1sen!2suk"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            className="rounded-md shadow"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default Contact;